import Vue from 'vue'
import App from './App.vue'
import '../../lib/base.css'

Vue.config.productionTip = false
Vue.config.devtools = false

const startApp = () => {
  new Vue({
    render: (h) => h(App),
  }).$mount('#app')
}

startApp()
